import { createRouter, createWebHistory } from 'vue-router';
import HelloWorld from "@/components/HelloWorld.vue";
import FundraiserDetails from "@/components/FundraiserDetails.vue";
import ContributePage from "@/components/ContributePage.vue";
import MpesaContribution from "@/components/MpesaContribution.vue";
import PayStackContribution from "@/components/PayStackContribution.vue";
import DepositConfirmation from "@/components/DepositConfirmation.vue";
import MakePledge from "@/components/MakePledge.vue";

const routes = [

    {
        path: '/',
        name: 'Home',
        component: HelloWorld,
    },
    {
        path: '/event/:id',
        name: 'FundraiserDetails',
        component: FundraiserDetails,
        props: true
    },
    {
        path: '/contribute/:id',
        name: 'ContributePage',
        component: ContributePage
    },
    {
        path: '/mpesa/:fundraiserId/:fundraiserName/:fundraiserIdentifier?',
        name: 'MpesaContribution',
        component: MpesaContribution,
        props: true
    },
    {
        path: '/paystack/:fundraiserId/:fundraiserName/:fundraiserIdentifier?',
        name: 'PayStackContribution',
        component: PayStackContribution
    },
    {
        path: '/pledge/:fundraiserId/:fundraiserName/:fundraiserIdentifier?',
        name: 'MakePledge',
        component: MakePledge
    },
    {
        path: '/deposit-confirmation/:paymentId/:transactionMessage/:fundraiserName/:fundraiserId?',
        name: 'DepositConfirmation',
        component: DepositConfirmation,
        props: true

    }



];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
